import { render } from "./M423_MenuContainer.vue?vue&type=template&id=41481529"
import script from "./M423_MenuContainer.vue?vue&type=script&lang=js"
export * from "./M423_MenuContainer.vue?vue&type=script&lang=js"

import "./M423_MenuContainer.vue?vue&type=style&index=0&id=41481529&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__